<!--
  @component
  Generates an SVG multi-series line chart. It expects your data to be an array of objects, each with a `values` key that is an array of data objects.
 -->
<script>
	import { blur } from "d3-array";
	import { line } from "d3-shape";
	import { getContext } from "svelte";
	import Line from "./Line.svelte";
	import Area from "./Area.svelte";
	import Point from "./Point.svelte";

	export let group;
	export let lineDrawDuration;
	export let rendered;

	const { data, xGet, yGet, zGet, zDomain, zRange, width } = getContext("LayerCake");

	let blurGenerator = () => {};
	$: {
		let radius = group.settings.trendline ? 2 : 0;
		blurGenerator = (values) => {
			let x_values = [];
			let y_values = [];

			for (const v of values) {
				x_values.push($xGet(v));
				y_values.push($yGet(v));
			}

			blur(y_values, radius);

			let new_values = x_values.map((x, i) => [x, y_values[i]]);

			return new_values;
		};
	}

	let path = () => {};
	$: {
		path = (values) => {
			let blurred = blurGenerator(values);
			return line(
				(d) => d[0],
				(d) => d[1]
			)(blurred);
		};
	}
</script>

{#if $width > 100}
	<g class="line-group">
		<Line {path} lineDrawDuration={group.settings.noAnimation ? 0 : lineDrawDuration} {group} bind:rendered />
		{#if !group.settings.trendline && !group.settings.faded}
			{#each group.values as point, i}
				<Point
					lineDrawDuration={group.settings.noAnimation ? 0 : lineDrawDuration}
					pointData={point}
					color={$zGet(group)}
					isLast={i === group.values.length - 1}
					highlight={group.settings.pointAnnotations?.find(({ date }) => {
						return (
							date.getFullYear() === point.year_month.getFullYear() && date.getMonth() === point.year_month.getMonth()
						);
					})}
				/>
			{/each}
		{/if}
		<Area {path} lineDrawDuration={group.settings.noAnimation ? 0 : lineDrawDuration} {group} />
		<!-- {#if group.settings.showTrendline} -->
		<!-- <Trendline
          {group}
        /> -->
		<!-- {/if} -->
		<!-- 
      {#if !group.settings.faded}
        <circle
          in:fade="{{duration: 300, delay: lineDrawDuration, ease: quintOut }}"
          class='point'
          cx={$xGet(group.values[group.values.length - 1])}
          cy={$yGet(group.values[group.values.length - 1])}
          r="3"
          fill="{$zGet(group)}"
        />
      {/if} -->
	</g>
{/if}
